import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { Button, Grid, Stack, Typography } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import DeleteDialog from '../../../components/admin/common/CustomDeleteDialog';
import { showCustomComponentNotification, showErrorNotification, showSuccessNotification, showWarningNotification, } from "../../../components/admin/common/NotiService";
import OZDataGrid from "../../../components/admin/common/OZDataGrid/OZDataGrid";
import OZGridToolbar from "../../../components/admin/common/OZDataGrid/OZGridToolbar";
import LoadingScreen from "../../../components/admin/common/OZLoadingScreen/OZLoadingScreen";
import { deletedispositionById, getdisposition, getDispositionById, importDispositions } from "../../../services/api-service";
import { NewAdminPages, newAuthPages, newAuthSubAdminAccess, writeAccess } from "../../../services/page-service";
import { useCheckBooleanSetting } from "../../../contexts/SettingsContext";
import "./Disposition.css";
import BulkDeleteDispositionDialog from "./BulkDeleteDispositionDialog";
import DispositionForm from "./DispositionForm";

function Disposition() {

  const CommentRenderer = (props) => {

    const [openDeleteConfirmationDialog, setDeleteConfirmationDialog] = useState(false);
    const [dispositionAnchorEl, setDispositionAnchorEl] = useState(null);
    const anchorRef = React.useRef();
    const [openRenameDialog, setRenameDialog] = useState(false);

    const onClickRename = () => {
      setDispositionAnchorEl(null);
      setRenameDialog(true);
    };

    const onClickDelete = (e) => {
      setDispositionAnchorEl(null);
      setDeleteConfirmationDialog(true);
    };

    const onMorevertIconClick = () => {
      setTimeout(() => setDispositionAnchorEl(anchorRef?.current), 1);
    };

    const onMenuClose = () => {
      setDispositionAnchorEl(null);
    };

    const onClickDeleteDialogClose = () => {
      setDeleteConfirmationDialog(false);
    };

    const onClickDeleteDialogDelete = () => {
      deletedisposition(props.data.id);
      setDeleteConfirmationDialog(false);
    };

    const styleListItemButton = useMemo(
      () => ({
        "&.MuiButtonBase-root": {
          color: '#212121',
          fontFamily: "Roboto",
          fontSize: "12px",
          fontWeight: 400,
          height: '16px',
          lineHeight: "14px",
        },
        '&:hover': {
          borderRadius: "4px",
        },
      }),
      []
    );

    return (
      <div className="oz-disposition-reason-container">
        <Typography sx={{
          fontFamily: "Roboto",
          fontSize: "14px",
          fontWeight: 400,
          color: "#212121",
          lineHeight: "16.41px",
          maxWidth: "200px",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}>{props.value}</Typography>
        {/* {authPage(AdminPages.DISPOSITIONS_EDIT) &&
          <img className="dispositionsMorevertIcon"
            onClick={onMorevertIconClick}
            src={`${process.env.PUBLIC_URL}/icons/more_vert.svg`} alt="edit"
          >
          </img>
        } */}
        {writeAccess() && (newAuthPages(NewAdminPages.DISPOSITIONS_PAGE) || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Full') || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Edit')) &&
          <img className="dispositionsMorevertIcon"
            onClick={onMorevertIconClick}
            src={`${process.env.PUBLIC_URL}/icons/more_vert.svg`} alt="edit"
          >
          </img>
        }
        <div ref={anchorRef}>
          <Menu anchorEl={dispositionAnchorEl} open={Boolean(dispositionAnchorEl)} onClose={onMenuClose} sx={{
            "& .MuiPaper-root": {
              backgroundColor: "#FFFFFF",
              width: "133px",
              height: "62px",
            },
            "& .MuiMenu-paper": {
              backgroundColor: "#FFFFFF",
              boxShadow: "0rem 0.25rem 0.75rem rgba(0, 0, 0, 0.04)",
              border: "0.0625rem solid #E6E5E6",
              borderRadius: "12px",
              marginLeft: "-0.3625rem",
              marginTop: "0rem",
            },
          }}>
            <MenuItem onClick={onClickRename} sx={{ ...styleListItemButton, marginTop: "1px" }}>Rename Reason </MenuItem>
            <MenuItem onClick={onClickDelete} sx={{ ...styleListItemButton, marginTop: '9px' }} disabled={!(newAuthPages(NewAdminPages.DISPOSITIONS_PAGE) || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Full'))}>Delete Reason</MenuItem>
          </Menu>
          {openDeleteConfirmationDialog &&
            <DeleteDialog title={"Delete Disposition"} content={" This will delete this " + props.data.reason + " disposition permanently. You cannot undo this action."} onClose={onClickDeleteDialogClose}
              open={true} deleteFunction={onClickDeleteDialogDelete} />
          }
          {openRenameDialog &&
            <DispositionForm updateReason={getDispositonList} onClose={() => { setRenameDialog(false) }} data={props.data} editAccess={(newAuthPages(NewAdminPages.DISPOSITIONS_PAGE) || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Full') || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Edit'))} />
          }
        </div>
      </div>
    );
  };

  const [dispositionForm, setDispositionForm] = useState({ isNew: false, show: false });
  const [dispositionList, setDispositionList] = useState([]);
  const [onRowclickDispositionData, setOnRowclickDispositionData] = useState(null);
  const [gridRef, setGridRef] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openBulkDeleteDisposition, setOpenBulkDeleteDisposition] = useState(false);
  const navigate = useNavigate();

  const bulkDeleteDispositionEnabled = useCheckBooleanSetting("BULK_DEL_DISP");
  // Same write + Full-access gate as the single "Delete Reason" action, behind the setting.
  const canBulkDeleteDisposition = bulkDeleteDispositionEnabled && writeAccess()
    && (newAuthPages(NewAdminPages.DISPOSITIONS_PAGE) || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Full'));

  const showDispositionForm = () => {
    setDispositionForm({ isNew: true, show: true });
  };

  const closeDispositionForm = () => {
    setDispositionForm({ isNew: false, show: false });
  };

  let buttonStyle = useMemo(
    () => ({
      borderRadius: "8px",
      height: "30px",
      fontSize: "14px",
      fontWeight: 400,
      width: "149px",
      backgroundcolor: "#3D8BF8",
      lineHeight: "16.41px",
    }),
    []
  );

  useEffect(() => {
    getDispositonList();
  }, []);

  async function getDispositonList() {
    setLoading(true);
    try {
      getdisposition()
        .then((resp) => {
          setDispositionList(resp.Data);
          setLoading(false);
        })
        .catch((e) => {
          setDispositionList([]);
          setLoading(false);
        });
    } catch (e) {
      setLoading(false);
      showErrorNotification("Error in disposiiton list");
    }
  };

  async function deletedisposition(dataId) {
    try {
      deletedispositionById(dataId)
        .then((resp) => {
          if (resp.Status === "Success") {
            getDispositonList();
            showSuccessNotification(resp.Message);
          }
          else {
            showWarningNotification(resp.Message);
          }
        })
        .catch((e) => {
          showErrorNotification("Error deleting disposition");
        });
    } catch (e) {
      showErrorNotification("Error in disposition delete");
    }
  };

  const columnDefs = [
    {
      field: "reason",
      headerName: "Reasons",
    },
    {
      field: "comments",
      headerName: "Description",
      cellRenderer: CommentRenderer,
    }
  ];

  function onClickSampleDownload() {
    const link = document.createElement("a");
    link.download = `disposition_upload_sample.xlsx`;
    link.href = `${process.env.PUBLIC_URL}/sample_files/disposition_upload_sample.xlsx`;
    link.click();
  };

  function onCLickRow(rowItem) {
    setOnRowclickDispositionData({});
    setDispositionForm({ isNew: false, show: true });
    try {
      getDispositionById(rowItem.data.id)
        .then((resp) => {
          setOnRowclickDispositionData(resp.Data[0]);
        })
        .catch((e) => {
          setOnRowclickDispositionData({});
        });
    } catch (e) {
      showErrorNotification("Error in disposition list ");
    }
  };

  async function dispositionsBulkUpload(formData) {
    try {
      const response = await importDispositions(formData);
      if (response?.Status === "Success") {
        showCustomComponentNotification({
          component: (
            <label style={{ fontSize: '14px', fontWeight: '400', color: '#212121' }}>
              Please allow some time as the report is being generated, it might take a while.
              <br />
              <span style={{ textDecoration: 'none', cursor: 'pointer', color: '#3d8bf8', fontSize: '12px', }}
                onClick={() => { navigate('/admin/reportStatusAdmin'); }}
              >
                Click here to Navigate to "Reports Status" Page
              </span>
            </label >
          ),
          variant: 'success',
        });
        return { code: 200, responseMessage: 'Disposition numbers upload initiated', skipDefaultSuccessNotification: true };
      }
      return { code: 500, responseMessage: response?.Message || 'Unable to upload Disposition numbers' };
    } catch (error) {
      return { code: 500, responseMessage: 'Unable to upload Disposition numbers' };
    }
  }
  return (
    <div className="ozAdminDispositionsContainer">
      <Grid sx={{ marginBottom: "10px" }}>
        <Typography className="oz-page-header"> Configurations </Typography>
      </Grid>
      <Stack direction="row" sx={{ marginBottom: "16px" }} justifyContent="space-between" alignItems="center">
        <Typography className="oz-page-heading"> Dispositions </Typography>
        <Stack direction="row" spacing={1.5} alignItems="center">
          {canBulkDeleteDisposition &&
            <Button
              sx={{ ...buttonStyle, width: "auto", paddingInline: "16px", textTransform: "none", whiteSpace: "nowrap" }}
              variant="outlined"
              color="error"
              startIcon={<DeleteOutlineOutlinedIcon />}
              onClick={() => setOpenBulkDeleteDisposition(true)}
            >
              Bulk Delete Disposition
            </Button>
          }
          {writeAccess() && (newAuthPages(NewAdminPages.DISPOSITIONS_PAGE) || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Full')) &&
            <Button
              sx={buttonStyle}
              variant="contained"
              startIcon={<AddBoxOutlinedIcon />}
              onClick={showDispositionForm}
            >
              New Reason
            </Button>
          }
        </Stack>
      </Stack>
      {dispositionForm.show && dispositionForm.isNew && (<DispositionForm disposition={getDispositonList} onClose={closeDispositionForm} />)}
      {dispositionForm.show && !dispositionForm.isNew && (
        <DispositionForm openDialog={true} updateReason={getDispositonList} onClose={closeDispositionForm} data={onRowclickDispositionData}
          editAccess={writeAccess() && (newAuthPages(NewAdminPages.DISPOSITIONS_PAGE) || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Full') || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Edit'))} />
      )}
      {openBulkDeleteDisposition && (
        <BulkDeleteDispositionDialog
          open
          onClose={() => setOpenBulkDeleteDisposition(false)}
          onDeleted={getDispositonList}
        />
      )}
      {/* <OZGridToolbar title='List of Dispositions' searchPlaceholder='Reasons' rowCount={dispositionList.length} dataGridRef={gridRef} fileName='Dispositions' showImport={authPage(AdminPages.DISPOSITIONS_EDIT)} importProps={{
        label: "Bulk Import Reasons", importFunction: importDispositions, fileName: "Disposition.xls", onClickSampleDownload: onClickSampleDownload
      }} refreshGrid={getDispositonList} /> */}
      <OZGridToolbar
        title='List of Dispositions'
        searchPlaceholder='Reasons'
        rowCount={dispositionList.length}
        dataGridRef={gridRef} fileName='Dispositions'
        showImport={writeAccess() && (newAuthPages(NewAdminPages.DISPOSITIONS_PAGE) || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'Full') || newAuthSubAdminAccess(NewAdminPages.DISPOSITIONS_PAGE, 'data'))} importProps={{
          label: "Bulk Import Reasons",
          importFunction: dispositionsBulkUpload,
          fileName: "Disposition.xlsx",
          onClickSampleDownload: onClickSampleDownload,
          acceptedFiles: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
          onlyXlsx: true
        }}
        refreshGrid={getDispositonList}
      />
      {loading ?
        (
          <div style={{ position: 'fixed', top: '0', left: '0', width: '100%', height: '100%', backgroundColor: '0,0,0,0.5', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }} >
            <LoadingScreen />
          </div>
        ) :
        (<>
          <OZDataGrid rowClickCallback={onCLickRow} height="26.3rem" data={dispositionList} columns={columnDefs} setGridRef={setGridRef} />
        </>
        )
      }
    </div>
  );
};

export default Disposition;